import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/store/store';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DatosPersonales from './domains/simulador/pages/datos_personales';
import LandingFVG from './domains/landingFVG/pages/landing';
import SimuladorFVG from './domains/simulador/pages/simulador';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import './assets/styles/variables.scss';
import { ROUTES } from './domains/paths';

function App() {
  return (
    <Router future={{
      v7_startTransition : true,
      v7_relativeSplatPath : true
    }}>
      <Provider store={store}>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CLAVE_WEB_RECAPTCHA}>
          <Routes>
            <Route exact path="/" element={<LandingFVG />} />
            <Route path={ROUTES.DATOS_PERSONALES} element={<DatosPersonales/>} />
            <Route path={ROUTES.SIMULADOR} element={<SimuladorFVG />} />
          </Routes>
        </GoogleReCaptchaProvider>
      </Provider>
    </Router>
  );
}

export default App;
